import {debounce} from "lodash"

export default {
  data() {
    return {
      listData: {
        hasNextPage: true,
        loading: false,
        data: [],
        query: {page_size: 20, page: 1},
      },
      pageSize: 20,
    }
  },

  methods: {
    loadListData() {
      if (!this.apiEndpoint)
        throw new Error("there is no api endpoint");

      this.beforeLoad();
      this.listData.loading = true;
      this.listData.query.page_size = this.pageSize;
      this.$http.get(this.apiEndpoint, {params:this.listData.query})
        .then(({data})=> {
          this.afterLoad(data);
        })
        .catch(() => {
          this.listData.loading = false;
        });
    },

    beforeLoad() {
      console.log('mixin beforeLoad');
    },

    afterLoad(data) {
      console.log('afterLoad', data);
      if (data.length < this.listData.query.page_size) {
        this.listData.hasNextPage = false;
      } else {
        this.listData.query.page++;
      }
      this.listData.data.push(...data);
      //console.log(listData);
      this.listData.loading = false;
      this.$refs.scrollView.finishLoadMore();
    },

    initListData() {
      this.listData = {
        hasNextPage: true,
        loading: false,
        data: [],
        query: {page_size: this.pageSize, page: 1},
      };
    },
    onReachBottom() {
        console.log('onReachBottom');
        if (!this.listData.hasNextPage)
            return;

        this.loadListData();
    },
    reflow:debounce(function(){
        console.log('reflow');
        this.$refs.scrollView.reflowScroller();
    }, 500),
  },


}
